<template lang="pug">
div.wrap-item-line-art-editor
  div.wrap-converter.f.fh
    ItemImgToLineArtConverter(ref="converter"
      :baseImgURL="baseImgURL" :screen="screen"
      :cannyParam="cannyParam" :grayScaleParam="grayScaleParam")
  div.wrap-slider.mb10
    v-range-slider(label="線"
      v-model="cannyParam.threshold"
      @change="changeCannyParam"
      min="30" max="120" step="1")
    v-range-slider(label="色"
      v-model="grayScaleParam.areaValues"
      @change="changeGrayScaleParam"
      min="0" max="255" step="1")
  div.f.mb12
    div(v-for="src in screenList"
      @click="onChangeScreenTone(src)"
      :class="{'active': src == screen}").wrap-screen.cursor-pointer.mr4
      v-img(:src="`/img/screen/${src}`")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$screen_size: 60px;
.wrap-item-line-art-editor {
  .wrap-converter {
    max-height: 70vh;
    overflow: hidden;
  }
  .wrap-screen {
    width: $screen_size; height: $screen_size;
    border: $basic_border;
    &.active {
      border: solid 1px $active_color;
    }
  }
}
</style>

<style lang="scss">
.wrap-item-line-art-editor {
  .wrap-slider {
    .v-input__slot {
      margin: 0 !important;
    }
    .v-messages {
      display: none !important;
    }
  }
}
</style>

<script>
import ItemImgToLineArtConverter from '@/components/item/asset-uploader/ItemImgToLineArtConverter'

export default {
  components: {
    ItemImgToLineArtConverter
  },
  props: {
    baseImgURL: {
      type: String,
      required: true
    },
    defaultAsset: {
      type: Object,
      default: null
    }
  },
  computed: {
    converter () {
      return this.$refs.converter
    }
  },
  data () {
    return {
      screen: 'no_screen.png',
      screenList: [
        'no_screen.png',
        'net1.png', 'net2.png',
        'stripe1.gif', 'stripe2.gif'
      ],
      cannyParam: {
        threshold: [50, 100],
        apertureSize: 3, L2gradient: false
      },
      grayScaleParam: {
        areaValues: [60, 120],
        pallete: [0, 178, 255]
      }
    }
  },
  // 変換処理が高速化したらこれにしよう
  // watch: {
  //   cannyParam: {
  //     handler () {
  //       console.log('cannyParam:')
  //       this.$refs.converter.generateLineArt()
  //     },
  //     deep: true
  //   }
  // },
  mounted () {
    if (this.defaultAsset) {
      if (this.defaultAsset.screen) {
        this.screen = this.defaultAsset.screen
        this.onChangeScreenTone(this.screen)
      }
      if (this.defaultAsset.cannyParam) {
        this.cannyParam = this.defaultAsset.cannyParam
        this.changeCannyParam()
      }
      if (this.defaultAsset.grayScaleParam) {
        this.grayScaleParam = this.defaultAsset.grayScaleParam
        this.changeGrayScaleParam()
      }
    }
  },
  methods: {
    onChangeScreenTone (src) {
      this.screen = src
      this.$nextTick(this.converter.generateLineArt)
    },
    async changeCannyParam () {
      // この処理を入れないと動かない
      this.converter.convertImageToLineDrawing('smoothingCanvas', 'lineArtCanvas')
      await this.converter.createResultImage(['lineArtCanvas', 'betaCanvas'])
      // -----------------------
      this.$nextTick(this.converter.generateLineArt)
    },
    changeGrayScaleParam () {
      this.$nextTick(this.converter.generateLineArt)
    },
    getResultImage () {
      return this.converter.resultBase64
    }
  }
}
</script>
